import { createStore, applyMiddleware, compose } from "redux";
import createDebounce from "redux-debounced";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import rootReducer from "./reducers";

const persistConfig = {
    // Root
    key: "root1",
    storage: storage,
    timeout: 10000,

    version: 1,

    // only the session needs to outlive a reload; admin/package hold server data
    // that every view refetches on mount, and persisting `loading` could rehydrate
    // a stuck spinner if the tab was closed mid-request
    whitelist: ["auth"],

    // merge one level deeper, so keys added to a persisted slice after a snapshot
    // was written are not wiped out by rehydration
    stateReconciler: autoMergeLevel2,
};

const middlewares = [thunk, createDebounce()];
const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(...middlewares)));

const persistor = persistStore(store);

export { store, persistor };
